import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ActivityNotesProp, {
  ACTIVITY_TYPE,
} from '../../propTypes/activityNotesProp';
import { formatDate } from '../../../../services/dateUtilityFunctions';
import { displayUserName } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import i18n from '../../../../services/i18n';
import { getOpportunityStatusTranslation } from '../../../opportunities/components/helpers/opportunitiesListHelper';

const DEFAULT_IMAGE = '/images/no_user.png';

const getMessage = (t, activity) => {
  const { type, user, note, status, document, lostReason } = activity;
  const userName = displayUserName(user);

  switch (type) {
    case ACTIVITY_TYPE.DOCUMENT:
      return (
        <p className="message-container">
          {i18n.__WithReact(
            'opportunity.document.uploaded',
            <span className="name">{userName}</span>,
            <a href={document?.url} target="_blank" rel="noopener noreferrer">
              {document?.originalName}
            </a>,
          )}
        </p>
      );
    case ACTIVITY_TYPE.STATUS:
      return (
        <p className="message-container">
          {i18n.__WithReact(
            'opportunity.status.updated',
            <span className="name">{userName}</span>,
            <span className="highlight">
              {getOpportunityStatusTranslation(status)}
            </span>,
          )}
        </p>
      );
    case ACTIVITY_TYPE.NOTE:
      return (
        <p className="message-container">
          {i18n.__WithReact(
            'opportunity.note.created',
            <span className="name">{userName}</span>,
            note,
          )}
        </p>
      );
    case ACTIVITY_TYPE.LOST_REASON:
      return (
        <p className="message-container">
          {i18n.__WithReact(
            'opportunity.note.lostReason',
            lostReason?.name,
            <span className="name">{userName}</span>,
          )}
        </p>
      );
    default:
      return <p />;
  }
};

function ActivityNote(props) {
  const { t, activity } = props;

  const { user, date } = activity;

  const image = useMemo(
    () => user?.image?.thumb || DEFAULT_IMAGE,
    [user?.image?.thumb],
  );
  const formattedDate = useMemo(
    () => formatDate(date, 'h:mm A D MMMM, YYYY'),
    [activity?.date],
  );

  return (
    <div className="activity-card">
      <div className="image-container">
        <img src={image} alt={DEFAULT_IMAGE} />
      </div>
      <div className="container">
        <div className="triangle" />
        <div className="content">
          {getMessage(t, activity)}
          <p className="date">{formattedDate}</p>
        </div>
      </div>
    </div>
  );
}

ActivityNote.propTypes = {
  t: PropTypes.func.isRequired,
  activity: PropTypes.shape(ActivityNotesProp.propType).isRequired,
};

export default translate(ActivityNote);
